import { Card, Grid, styled } from '../../base';

export const LoginWrapper = styled('div')(({ theme }) => ({
    minHeight: '100vh',
    background: theme.palette.background.mainBackground,
    display: 'flex',
    justifyContent: 'center',
}));

export const LoginCard = styled(Card)(({ theme }) => ({
    padding: theme.spacing(3),
    maxWidth: '1430px',
    maxHeight: '782px',
    minHeight: '600px',
    display: 'flex',
    justifyContent: 'center',
    alignSelf: 'center',
}));

export const LoginGrid = styled(Grid)(() => ({
    height: '100%',
    alignSelf: 'center',
}));

export const LogoWrapper = styled('div')(() => ({
    height: '100%',
    justifyContent: 'center',
    maxWidth: '100%',
}));
